import { render, staticRenderFns } from "./ClassLearningAlert.vue?vue&type=template&id=45cea8d4&"
import script from "./ClassLearningAlert.vue?vue&type=script&lang=js&"
export * from "./ClassLearningAlert.vue?vue&type=script&lang=js&"
import style0 from "./ClassLearningAlert.vue?vue&type=style&index=0&id=45cea8d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports